import { ChecklistMetricStatus } from '../../handoff-checklist-v2/handoff-checklist-v2.types';
import { VoiceAirMetricDefinition } from '../voice-air-metrics.types';
import { getSchedulingAppointmentTypesQueryOptions } from '../voice-air-handoff.queries';
import { getParsedErrorMessage } from 'redux/axios';
import { WEAVE_APP_URL } from 'apis/sso/sso-url-config';

export const schedulingServiceTypeMetric: VoiceAirMetricDefinition = {
  id: 'scheduling_service_type',
  name: 'Scheduling Service Type',
  isRequired: true,
  criteria: [
    {
      description: 'Verify service types mapping exists for scheduling appointments.',
      whereToFix: {
        label: 'Scheduling Settings',
        url: `${WEAVE_APP_URL}/home/dashboard#settings/schedule/services`,
      },
      evaluate: async (ctx) => {
        try {
          const resp = await ctx.queryClient.fetchQuery(
            getSchedulingAppointmentTypesQueryOptions(ctx.locationId, ctx.orgId)
          );

          const appointmentTypes = resp?.appointmentTypes;

          if (!appointmentTypes || appointmentTypes.length === 0) {
            return {
              status: ChecklistMetricStatus.BLOCKED,
              reason: 'scheduling_service_type_missing',
              message:
                'No scheduling service type is configured. At least one service type must be created.',
            };
          }

          return {
            status: ChecklistMetricStatus.PASSED,
            reason: 'scheduling_service_type_configured',
            message: 'At least one scheduling service type is configured.',
          };
        } catch (err) {
          return {
            status: ChecklistMetricStatus.BLOCKED,
            reason: 'api_request_failed',
            message:
              getParsedErrorMessage(err) ||
              'Failed to verify active scheduling service types.',
          };
        }
      },
    },
  ],
};
